import { FC, ReactElement, useCallback } from 'react';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import AlertTitle from '@mui/material/AlertTitle';

type Props = {
  fallback?: ReactElement;
  children?: ReactElement;
};

const ErrorBoundary: FC<Props> = ({ fallback, children }) => {
  const handleReloadClick = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <SentryErrorBoundary
      fallback={
        fallback ?? (
          <Box sx={{ p: 2 }}>
            <Alert
              severity="error"
              variant="filled"
              action={
                <Button
                  color="inherit"
                  size="small"
                  onClick={handleReloadClick}>
                  Perkrauti
                </Button>
              }>
              <AlertTitle>Klaida</AlertTitle>
              Įvyko nenumatyta klaida, jei puslapio perkovimas nepadeda, prašome
              kreiptis į sistemos administratorius
            </Alert>
          </Box>
        )
      }>
      {children}
    </SentryErrorBoundary>
  );
};

export default ErrorBoundary;
